module.exports = __webpack_public_path__ + "media/luxury-2026/estate-arrival-roof-cleaned-960-f2c6f5ad.jpg";